import React from "react";
import appIcons from "./icons";
import IComponentAppIcon from "./interface";

const AppIcons: React.FC<IComponentAppIcon> = ({
	name,
	size,
	...rest
}) => {
	const Icon = appIcons[name];
	return <Icon width={size || 24} height={size || 24} {...rest} />;
};

export default AppIcons;
